"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import Image from "next/image";
import Tilt from "@/components/ui/ResponsiveTilt";
import { motion } from "framer-motion";
import { shopifyHiringModels, ShopifyHiringModel } from "./shopify.data";
import { ShopifyExpertsBadge } from "@/components/common/BrandExpertsBadge";
const EASE: [number, number, number, number] = [0.25, 0.1, 0.25, 1];
const CARD_SHADOW = "shadow-[0_4px_24px_rgba(0,0,0,0.06)]";
interface ShopifyHiringModelsProps {
  heading?: string;
  subtitle?: string;
  models?: ShopifyHiringModel[];
  className?: string;
}
export default function ShopifyHiringModels(t0) {
  const $ = _c(33);
  const {
    heading: t1,
    subtitle: t2,
    models: t3,
    className: t4
  } = t0;
  const heading = t1 === undefined ? "Hiring Models For Our Shopify Developers!!" : t1;
  const subtitle = t2 === undefined ? "Choose from our flexible and transparent hiring models tailored to fit your project scope, budget, and business timeline requirements." : t2;
  const models = t3 === undefined ? shopifyHiringModels : t3;
  const className = t4 === undefined ? "" : t4;
  const desktopAnimations = useDesktopAnimations();
  const t5 = `relative overflow-hidden bg-white py-16 font-sans transition-colors duration-300 sm:py-20 lg:py-24 dark:bg-[#070b14] ${className}`;
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="pointer-events-none absolute inset-0 opacity-40 bg-[radial-gradient(circle,rgba(75,88,125,.18)_0.8px,transparent_0.9px)] bg-[length:12px_12px]" aria-hidden="true" />;
    $[0] = t6;
  } else {
    t6 = $[0];
  }
  let t7;
  if ($[1] !== desktopAnimations) {
    t7 = desktopAnimations ? {
      opacity: 0,
      y: 30
    } : false;
    $[1] = desktopAnimations;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  let t8;
  if ($[3] !== desktopAnimations) {
    t8 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[3] = desktopAnimations;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== desktopAnimations) {
    t9 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[5] = desktopAnimations;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  let t11;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      once: true
    };
    t11 = {
      duration: 0.8,
      ease: EASE
    };
    $[7] = t10;
    $[8] = t11;
  } else {
    t10 = $[7];
    t11 = $[8];
  }
  let t12;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="mb-4 flex justify-center"><ShopifyExpertsBadge /></div>;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  let t13;
  if ($[10] !== heading) {
    t13 = <h2 className="font-poppins text-[30px] font-bold leading-tight text-[#0b1354] sm:text-[38px] lg:text-[44px] dark:text-white">{heading}</h2>;
    $[10] = heading;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  let t14;
  if ($[12] !== subtitle) {
    t14 = subtitle && <p className="font-sans mt-3 text-[14.5px] font-normal leading-[26px] text-[#66698a] sm:text-[16px] dark:text-gray-400">{subtitle}</p>;
    $[12] = subtitle;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] !== t13 || $[15] !== t14 || $[16] !== t7 || $[17] !== t8 || $[18] !== t9) {
    t15 = <motion.div initial={t7} whileInView={t8} animate={t9} viewport={t10} transition={t11} className="mx-auto mb-12 max-w-3xl text-center md:mb-16">{t12}{t13}{t14}</motion.div>;
    $[14] = t13;
    $[15] = t14;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== desktopAnimations || $[21] !== models) {
    let t17;
    if ($[23] !== desktopAnimations) {
      t17 = (model, idx) => <motion.div key={model.id} initial={desktopAnimations ? {
        opacity: 0,
        y: 40
      } : false} whileInView={desktopAnimations ? {
        opacity: 1,
        y: 0
      } : undefined} animate={desktopAnimations ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0
      }} whileHover={desktopAnimations ? {
        y: -8,
        transition: {
          duration: 0.3,
          ease: "easeOut"
        }
      } : undefined} transition={{
        duration: 0.9,
        delay: idx * 0.15,
        ease: EASE
      }} className="h-full"><Tilt tiltMaxAngleX={6} tiltMaxAngleY={6} perspective={1000} transitionSpeed={1000} scale={1} className="h-full"><article className={`group relative flex h-full min-h-[290px] flex-col justify-start overflow-hidden rounded-[20px] border-b-4 p-7 transition-all duration-500 sm:p-8 ${CARD_SHADOW} ${model.bg} ${model.border} ${model.darkBg || "dark:bg-slate-900"} ${model.darkBorder || "dark:border-b-slate-700"}`}><div className="mb-5 max-h-20 overflow-hidden opacity-100 transition-all duration-500 ease-out group-hover:mb-0 group-hover:max-h-0 group-hover:opacity-0"><Image src={model.icon} alt={model.alt} width={64} height={64} loading="lazy" className="h-14 w-14 object-contain sm:h-16 sm:w-16" /></div><h3 className="font-poppins mb-3 text-[20px] font-bold leading-tight text-[#0b1354] transition-all duration-500 ease-out sm:text-[22px] dark:text-white">{model.title}</h3><p className="font-sans text-[14.5px] leading-[26px] text-[#5e6282] transition-all duration-500 ease-out sm:text-[15.5px] dark:text-gray-300">{model.description}</p></article></Tilt></motion.div>;
      $[23] = desktopAnimations;
      $[24] = t17;
    } else {
      t17 = $[24];
    }
    t16 = models.map(t17);
    $[20] = desktopAnimations;
    $[21] = models;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[25] !== t16) {
    t17 = <div className="grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">{t16}</div>;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t15 || $[28] !== t17) {
    t18 = <div className="relative z-10 mx-auto w-full max-w-[1280px] px-4 sm:px-6 lg:px-8">{t15}{t17}</div>;
    $[27] = t15;
    $[28] = t17;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t18 || $[31] !== t5) {
    t19 = <section className={t5}>{t6}{t18}</section>;
    $[30] = t18;
    $[31] = t5;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  return t19;
}